<script>
import CustomerSearch from "../CustomerSearch.vue";
import Service from "../../services/FormService";
import UsesErrors from "../../mixins/UsesErrors";
import UsesInfoMessage from "../../mixins/UsesInfoMessage";
import UsesFormRouteQuery from "../../mixins/UsesFormRouteQuery";
import JobService from "../../services/JobService";
import TextRow from "./parts/TextRowComponent.vue";
import DateRow from "./parts/DateRowComponent.vue";
import SelectRow from "./parts/SelectRowComponent.vue";
import CheckboxRow from "./parts/CheckboxRowComponent.vue";
import moment from "moment";
import AuditRows from "./parts/AuditRows.vue";

const initialDoor = {
    ref: '',
    info: '',
    location: '',
    potential_risk: '',
    defects: '',
    corrective_actions: '',
    fire_rating: '',
    leaf_a_width: '',
    leaf_a_height: '',
    leaf_a_thickness: '',
    leaf_b_width: '',
    leaf_b_height: '',
    leaf_b_thickness: '',
    has_label: '',
    free_from_damage: '',
    veneered_or_lipped: '',
    leaf_flush: '',
    frame_width: '',
    frame_height: '',
    firmly_attached: '',
    leaf_material_checked: '',
    lipping_thickness: '',
    twisting_of_leaf: '',
    damage_or_cracking: '',
    type_of_self_closer: '',
    self_closer_attached: '',
    self_closer_damaged: '',
    close_and_latch: '',
    unlatched_holds_in_frame: '',
    latch_rattling: '',
    pairs_close: '',
    planted_door_stop_attached: '',
    hold_open_devices: '',
    frame_to_door_gap: '',
    bottom_gap_consistent_closed: '',
    bottom_gap_measurement: '',
    bottom_gap_consistent_swing: '',
    intumescent_seals_paint: '',
    intumescent_seals_attached: '',
    intumescent_seals_attached_info: '',
    intumescent_seals_damage: '',
    intumescent_seals_size_type: '',
    intumescent_seals_size_issue: '',
    threshold_smoke_seal_damage: '',
    threshold_smoke_seal_damage_type: '',
    brush_fin_smoke_seal_damage: '',
    hinges_marked: '',
    hinges_number: '',
    hinges_min_screws: '',
    hinges_damage: '',
    number_vision_panels: '',
    panels_safety_class: '',
    glass_intumescent_seal: '',
    glass_beads_damage: '',
    glass_damage: '',
    glass_replaced: '',
    letter_box_fitted: '',
    letter_box_markings: '',
    letter_box_size: '',
    letter_box_framing: '',
    letter_box_height: '',
    vent_grill_fitted: '',
    vent_grill_markings: '',
    vent_grill_size: '',
    vent_grill_height: '',
    panel_makeup: '',
    panel_size: '',
    type_of_glass: '',
    side_panel_beading: '',
    identity_mark_on_glass: '',
    panel_fixing_method: '',
    corrective_actions_comments: '',
    photos: [],
};

const initialForm = {
    type: 'fire_door_inspection',
    customer_id: null,
    customer: {},
    site_id: null,
    doc_no: '',
    engineer_id: null, // Assessor
    number_single_doors: 0,
    number_double_doors: 0,
    number_doors_and_halves: 0,
    total_number_doors: 0,
    total_number_audits: 0,
    number_pictures: 0,
    assessment_date: moment().format('L'),
    last_survey_created: '',
    number_non_compliant_doors: 0,
    number_actions: 0,
    doors: [
        {...initialDoor},
    ],
};

export default {
    components: {
        AuditRows,
        TextRow,
        CustomerSearch,
        DateRow,
        SelectRow,
        CheckboxRow,
    },
    mixins: [
        UsesErrors,
        UsesInfoMessage,
        UsesFormRouteQuery,
    ],
    data: function () {
        return {
            form: {
                ...initialForm,
            },
            token: null,
            jobs: [],
            openDoorIndex: 0,
        }
    },
    computed: {
        canDelete() {
            return window.AuthService.user.admin_access || window.AuthService.user.office_access;
        },
        formId() {
            return this.$route.params.id;
        },
        photosCount() {
            let count = 0;
            this.form.doors.forEach(door => {
                if (door.photos && door.photos.length) {
                    count += door.photos.length;
                }
            });
            return count;
        },
    },
    watch: {
        formId: {
            handler() {
                if (this.formId) {
                    this.loadForm();
                    return;
                }
                Service.nextNo().then(res => {
                    this.form.doc_no = res.data;
                });
            },
            immediate: true,
        },
        photosCount: {
            handler(newValue) {
                this.form.number_pictures = newValue;
            },
            immediate: true,
        },
    },
    mounted() {
        this.populateFormFromRouteQuery();
    },
    methods: {
        onJobLoadedFromRoute() {
            this.siteChanged();
        },

        saveForm() {
            this.setSaving();
            this.clearErrors();

            this.form.doors = this.form.doors.map((door) => {
                door.photos = door.photos.filter(photoRow => photoRow.photo_url || photoRow.content);

                return door;
            })

            let data = {...this.form};
            delete data['customer'];
            delete data['site'];
            delete data['job'];
            delete data['data'];

            if (this.form.id) {
                Service.update(data).then(
                    res => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        this.$emit('formSaved', res.data);
                    },
                    err => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            } else {
                Service.create(data).then(
                    res => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        if (this.$route.path.includes('engineer/')) {
                            this.$router.push({
                                name: "engineer.forms.edit",
                                params: {
                                    id: res.data.id
                                }
                            });
                        } else {
                            this.$router.push({
                                name: 'office.forms.edit',
                                params: {
                                    id: res.data.id
                                }
                            });
                        }
                    },
                    err => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            }
        },
        deleteForm() {
            if (confirm("Are you sure you want to delete this form?")) {
                Service.delete(this.form).then(
                    () => {
                        this.setInfoMessage("Form successfully deleted");
                        this.$router.push({name: 'office.forms.search'});
                    },
                    error => {
                        this.setErrorMessage("Could not delete this form");
                        console.error(error);
                    }
                )
            }
        },
        loadForm() {
            this.setLoading();
            Service.get(this.formId).then(res => {
                this.form = {
                    ...initialForm,
                    ...res.data,
                };

                if (!this.form.customer) {
                    this.form.customer = {
                        company_name: '',
                    };
                }

                this.getJobs();
                this.siteChanged();
            }).catch(err => {
                this.setErrorMessage('Could not load form');
                throw err;
            }).then(() => {
                this.clearLoading();
            });
        },
        getJobs() {
            if (!this.form.customer_id) {
                this.jobs = [];
                this.form.job_id = null;
                return;
            }
            JobService.search({'filter[customer_id]': this.form.customer_id}).then(res => {
                this.jobs = res.data.data || [];
            }, err => {
                this.setErrorMessage('Could not load customer jobs');
                this.jobs = [];
                throw err;
            });
        },
        customerChanged(newCustomer) {
            if (!newCustomer) {
                this.form.customer = {};
                this.form.customer_id = null;
                this.form.site_id = null;
                this.siteChanged();
                this.getJobs();
                return;
            }
            this.form.customer = newCustomer;
            this.form.customer_id = newCustomer.id;
            this.getJobs();
            if (newCustomer && newCustomer.sites) {
                if (!newCustomer.sites.map(site => site.id).includes(this.form.site_id)) {
                    this.form.site_id = '';
                    this.siteChanged();
                }
            } else {
                this.form.site_id = '';
                this.siteChanged();
            }
        },
        siteChanged() {
            // Not used currently
        },
        openDoor(index) {
            this.openDoorIndex = this.openDoorIndex === index ? undefined : index;
            window.setTimeout(() => {
                document.querySelector(`.door-toggle-${index}`).scrollIntoView({behavior: 'smooth' });
            }, 300);
        },
        addDoor() {
            this.form.doors.push({...initialDoor});
            this.openDoorIndex = Math.max((this.form.doors.length - 1), 0);
        },
        removeDoor(index) {
            const check = window.confirm("Are you sure you want to remove this door?");
            if (!check) {
                return true;
            }

            this.form.doors.splice(index, 1);
            this.$forceUpdate();
        },
        autofillCorrectiveActions(index) {
            const door = this.form.doors[index];

            if (door.corrective_actions_comments && door.corrective_actions_comments !== '') {
                const confirmOverride = window.confirm("This door already has corrective actions filled in. Do you want to override them?");
                if (!confirmOverride) {
                    return;
                }
            }

            const comments = [
                {
                    text: 'A fire door that has undergone rigorous testing and third-party certification.',
                    include: door.has_label === 'Certified'
                },
                {
                    text: 'A fire door that was built to meet the fire resistance standards that were in place when the building was constructed.',
                    include: door.has_label === 'Notional'
                },
                {
                    text: 'A timber-based door that is deemed a fire door by a fire door inspector, but has not undergone official third-party testing for certification.',
                    include: door.has_label === 'Nominal'
                },
                {
                    text: 'Damage (dents, chips, holes, or open joints) is present on the door leaf or frame, compromising fire integrity. The damaged area must be repaired using appropriate fire-rated materials or the door/frame must be replaced.',
                    include: door.free_from_damage === 'No',
                },
                {
                    text: 'The veneer/lipping is loose. This loss of material integrity compromises the door\'s fire rating and MUST be repaired or replaced by a competent person.',
                    include: door.veneered_or_lipped === 'No',
                },
                {
                    text: 'The door leaf is distorted/warped. There is a gap excessive of 4mm between the door leaf and the door stop. This gap exceeds the recommended maximum clearance and compromises the smoke and fire seal. The door must be repaired or replaced by a competent person.',
                    include: door.leaf_flush === 'No',
                },
                {
                    text: 'The door frame is loose or not firmly attached to the wall. The frame must be re-secured using approved fixings to ensure stability and proper operation of the fire door assembly.',
                    include: door.firmly_attached === 'No',
                },
                {
                    text: 'Certified Fire Door',
                    include: door.leaf_material_checked === 'Yes',
                },
                {
                    text: 'If the label is missing, painted over, or illegible, the door\'s material/rating cannot be verified.',
                    include: door.leaf_material_checked === 'No',
                },
                {
                    text: 'The door leaf is severely warped/twisted. The door must be replaced as repair is unlikely or uneconomical.',
                    include: door.twisting_of_leaf === 'Yes',
                },
                {
                    text: 'A vertical split/crack is present, depending on severity, the frame will need to be repaired with fire-rated filler or the entire frame replaced to restore integrity.',
                    include: door.damage_or_cracking === 'Yes',
                },
                {
                    text: 'The closer is loose, damaged, or incorrectly fitted. This needs to be repaired immediately by a competent person to ensure the door can fully close and latch.',
                    include: door.self_closer_attached === 'No',
                },
                {
                    text: 'This door requires a self-closing device to be compliant as a fire door. A certified closer must be installed by a competent person.',
                    include: door.self_closer_attached === 'N/A',
                },
                {
                    text: 'The door closer is damaged or leaking oil. The closer must be replaced immediately as its function (ensuring door closure) is compromised, which fails a critical fire safety requirement.',
                    include: door.self_closer_damaged === 'No',
                },
                {
                    text: 'The door did not fully close, or it closed but did not fully engage the latch/door stop. The closer\'s closing force and/or latching speed are likely set incorrectly and need immediate adjustment by a competent person. If adjustment fails, the closer must be replaced.',
                    include: door.close_and_latch === 'No',
                },
                {
                    text: 'The latch does not hold the door firmly and allows the door to rattle, or the latch does not engage properly. This is usually due to a misalignment of the latch plate/keep in the frame, or a worn/damaged latch mechanism. The mechanism must be adjusted or replaced by a competent person to ensure the door remains secure during a fire and is not easily opened by pressure.',
                    include: door.unlatched_holds_in_frame === 'No',
                },
                {
                    text: 'The closer is failing to hold the door leaf in line with the frame when unlatched (door is not closing squarely). The closer mechanism/setting requires adjustment or replacement to ensure proper alignment and seal compression.',
                    include: door.latch_rattling === 'No',
                },
                {
                    text: 'The doors are failing to close correctly in sequence, which means they will not seal properly. This is usually caused by a missing, damaged, or incorrectly adjusted door coordinator/sequence device. This must be repaired or adjusted by a competent person to ensure the inactive leaf closes first and the active leaf closes second.',
                    include: door.pairs_close === 'No',
                },
                {
                    text: 'The planted door stop is loose or damaged (e.g., screws are stripped, wood is split). If it detaches in a fire, it will create a large gap between the door and the frame, allowing fire and smoke to pass. It must be immediately re-secured with appropriate fixings (e.g., screws) or replaced by a competent person. All gaps between the door stop and the frame/wall must be correctly sealed with fire-rated mastic.',
                    include: door.planted_door_stop_attached === 'No',
                },
                {
                    text: 'The hold-open device did not release when required (e.g., during testing or fire signal simulation). The electronic release mechanism must be repaired, replaced, or tested to ensure fail-safe operation upon fire alarm activation.',
                    include: door.hold_open_devices === 'No',
                },
                {
                    text: 'The gap between the door leaf and frame is outside the acceptable range (2mm to 4mm). The door leaf or frame requires adjustment, shimming, or repair to achieve the correct, consistent fire-rated gap.',
                    include: door.frame_to_door_gap === 'No',
                },
                {
                    text: 'The bottom gap exceeds the maximum allowed tolerance of 10mm. Install a suitable fire-rated threshold seal, smoke seal, or door shoe to reduce the gap below 10mm and restore fire/smoke integrity.',
                    include: door.bottom_gap_consistent_closed === 'No',
                },
                {
                    text: 'The gap under the door is either too large or too small/inconsistent. If the door is dragging on the floor (too small), it must be re-hung or trimmed. More importantly, if the gap exceeds the maximum allowable limit (usually 8 mm, but check manufacturer specs), it must be addressed immediately with a threshold seal or door replacement as this compromises smoke containment.',
                    include: door.bottom_gap_consistent_swing === 'No',
                },
                {
                    text: 'The intumescent seals are contaminated with paint or varnish, which can inhibit their expansion in a fire. Carefully remove the paint/varnish (if possible without damaging the seal) or replace the seals entirely.',
                    include: door.intumescent_seals_paint === 'No',
                },
                {
                    text: 'The intumescent seals are contaminated with paint or varnish, which can inhibit their expansion in a fire. Carefully remove the paint/varnish (if possible without damaging the seal) or replace the seals entirely.',
                    include: door.intumescent_seals_attached === 'No',
                },
                {
                    text: 'The seal is peeling away from the groove, is not fully inserted, or is rattling (indicating a seal that is too small for the groove).',
                    include: door.intumescent_seals_attached_info === 'Loose/Detached'
                },
                {
                    text: 'The seal is too large for the groove, causing it to bulge, which puts strain on the door closer and prevents the door from fully latching.',
                    include: door.intumescent_seals_attached_info === 'Compressed/Straining'
                },
                {
                    text: 'The seal is an unspecified type or is too thin for the required fire rating. All poorly fitted seals must be replaced with the correct certified size and type by a competent person.',
                    include: door.intumescent_seals_attached_info === 'Incorrect Type'
                },
                {
                    text: 'Damaged seals must be replaced immediately by a competent person.',
                    include: door.intumescent_seals_damage === 'No'
                },
                {
                    text: 'The seals are loose, rattling in the groove, or there are gaps visible between the seal and the groove walls. This may prevent full expansion.',
                    include: door.intumescent_seals_size_issue === 'Too small'
                },
                {
                    text: 'The seals are compressed or bulging, putting strain on the door closer or preventing the door from fully latching. Both scenarios compromise the fire integrity. Seals must be replaced with the correct certified size and type by a competent person.',
                    include: door.intumescent_seals_size_issue === 'Too big'
                },
                {
                    text: 'The seal is not fully seated in the groove, is peeling away, or can be easily pulled out, meaning the adhesive or fit is inadequate.',
                    include: door.threshold_smoke_seal_damage_type === 'Loose/Peeling'
                },
                {
                    text: 'The seal is rattling or there are gaps visible between the seal and the groove walls, indicating it is too small for the channel and will fail to properly seal.',
                    include: door.threshold_smoke_seal_damage_type === 'Gaps/Rattling'
                },
                {
                    text: 'The seal is not installed to the correct depth in the groove, causing it to sit either too proud (preventing full closure) or too deep (making it ineffective). All poorly fitted seals must be replaced with the correct certified size and type and properly secured by a competent person.',
                    include: door.threshold_smoke_seal_damage_type === 'Improper Depth'
                },
                {
                    text: 'The smoke seal is damaged, torn, compressed, or broken. For example, the brushes are missing/matted, or the fins are torn/bent. Smoke seals must be immediately replaced by a competent person, as any break or defect will allow the passage of cold smoke.',
                    include: door.brush_fin_smoke_seal_damage === 'No'
                },
                {
                    text: 'The hinges are not marked with the required BS or EN number, this means the hinges cannot be verified as suitable for a fire door, and the entire fire door assembly is compromised. All hinges must be replaced with the correct certified type and installed by a competent person.',
                    include: door.hinges_marked === 'No'
                },
                {
                    text: 'The door is fitted with fewer than the minimum of 3 hinges or is missing screws. Install the required number of hinges (minimum 3) or replace all missing screws immediately to ensure the door leaf is securely supported.',
                    include: door.hinges_min_screws === 'No'
                },
                {
                    text: 'The glazing is either not safety glass or the glass is not marked with the appropriate safety kitemark (e.g., BS EN 12150, BS 6206). Glazing below 1500mm from the floor is in a critical zone and must be safety-rated to prevent serious injury upon impact. Remedial action: The glass must be replaced with appropriately marked and certified safety glass.',
                    include: door.panels_safety_class === 'No'
                },
                {
                    text: 'The intumescent strip is missing, damaged, or discontinuous between the glass and the bead/rebate. If the seal is missing or broken, the integrity of the glazing system is compromised, and the glass will not be held securely in place during a fire. The required fire-rated glazing material (putty, mastic, or strip) must be correctly installed immediately by a competent person.',
                    include: door.glass_intumescent_seal === 'No'
                },
                {
                    text: 'Non-certified packing (e.g., cardboard, non-approved shims) is visible behind the hinge plate. Only certified fire-rated hinge pads/mastic is acceptable.',
                    include: door.glass_beads_damage_type === 'Packing Present'
                },
                {
                    text: 'There are metal fragments (swarf) around the hinge or it appears to be grinding, indicating severe wear and potential failure.',
                    include: door.glass_beads_damage_type === 'Metal Fragments/Damage'
                },
                {
                    text: 'Oil or grease is leaking from the hinge barrels. This often indicates the hinge is defective, poorly lubricated, or has been wrongly specified, and it compromises the hinge\'s longevity. The hinges must be repaired or replaced with certified products by a competent person.',
                    include: door.glass_beads_damage_type === 'Oil Leakage'
                },
                {
                    text: 'The glazing panel has damage (e.g., scratches, deep chips) or cracking. Even minor cracking can destroy the integrity of the fire-rated glass, causing it to fail prematurely in a fire. The glass must be replaced immediately with a new, correctly certified, and fire-rated pane by a competent glazer.',
                    include: door.glass_damage === 'No'
                },
                {
                    text: 'The replacement glass is not fire-rated (i.e., it lacks the correct permanent etching/marking or the documentation is missing). Standard or safety-only glass will fail, allowing fire and smoke spread. The glass must be immediately replaced with a new, correctly certified, and fire-rated pane (e.g., marked FD30 or FD60) installed by a competent glazer using the correct intumescent seals and beads.',
                    include: door.glass_replaced === 'No'
                },
            ];

            this.form.doors[index].corrective_actions_comments = comments.filter(c => c.include).map(c => c.text).join('\n\n');
        },

        handleVisionPanelsChanged(index) {
            const door = this.form.doors[index];
            if (door.number_vision_panels && door.number_vision_panels > 0) {
                door.panels_safety_class = '';
                door.glass_intumescent_seal = '';
                door.glass_beads_damage = '';
                door.glass_damage = '';
                door.glass_replaced = '';
                door.glass_beads_damage_type = '';

                this.form.doors[index] = door;
                return;
            }

            door.panels_safety_class = 'N/A';
            door.glass_intumescent_seal = 'N/A';
            door.glass_beads_damage = 'N/A';
            door.glass_beads_damage_type = '';
            door.glass_damage = 'N/A';
            door.glass_replaced = 'N/A';

            this.form.doors[index] = door;
        },
    },
};
</script>

<template>
    <div class="container-fluid form-container fire-ex-service-form-container">
        <div class="row">
            <div class="col-sm-12">
                <h1 class="page-title">
                    Fire Door Inspection
                </h1>
            </div>
        </div>
        <form
            action=""
            class="fire-alarm-test-form"
            @submit.prevent="saveForm()"
        >
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Customer Details</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="customer">Customer</label>
                            <customer-search
                                ref="customerSearch"
                                :customer="form.customer"
                                @change="customerChanged"
                                :customer-id="form.customer_id"
                            />
                            <error
                                name="customer_id"
                                :errors="errors"
                            />
                        </div>
                        <div
                            class="col-sm-12 col-md-6 form-group"
                            v-if="form.customer && form.customer.sites"
                        >
                            <label for="site">Site:</label>
                            <select
                                name="site"
                                v-model="form.site_id"
                                id="site"
                                class="form-control"
                                placeholder="Site"
                                required
                                v-if="form.customer.sites.length"
                                @change="siteChanged()"
                            >
                                <option value="">
                                    Select Site
                                </option>
                                <option
                                    v-for="site in form.customer.sites"
                                    :key="site.id"
                                    :value="site.id"
                                >
                                    #{{ site.site_no }} {{ site.name }}
                                </option>
                            </select>
                            <span
                                class="form-error"
                                v-if="!form.customer.sites.length"
                            >This customer has no sites</span>
                            <error
                                name="site_id"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="job_id">Job No.</label>
                            <select
                                name="job_id"
                                id="job_id"
                                v-model="form.job_id"
                                class="form-control"
                                placeholder="Select a job"
                                :disabled="!jobs || jobs.length < 1"
                            >
                                <option
                                    :value="null"
                                    disabled
                                >
                                    Select a job
                                </option>
                                <option
                                    v-for="job in jobs"
                                    :key="job.id"
                                    :value="job.id"
                                >
                                    {{ job.id }}: {{ job.name }}
                                </option>
                            </select>
                            <error
                                name="job_id"
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Schedule of Doors</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <text-row
                                label="No. of single doors"
                                v-model="form.number_single_doors"
                                type="number"
                                min="0"
                                step="1"
                                name="number_single_doors"
                                id="number_single_doors"
                                wide
                                :errors="errors"
                            />

                            <text-row
                                label="No. of double doors"
                                v-model="form.number_double_doors"
                                type="number"
                                min="0"
                                step="1"
                                name="number_double_doors"
                                id="number_double_doors"
                                wide
                                :errors="errors"
                            />

                            <text-row
                                label="No. of doors and halves"
                                v-model="form.number_doors_and_halves"
                                type="number"
                                min="0"
                                step="1"
                                name="number_doors_and_halves"
                                id="number_doors_and_halves"
                                wide
                                :errors="errors"
                            />

                            <text-row
                                label="Total no. of doors"
                                v-model="form.total_number_doors"
                                type="number"
                                min="0"
                                step="1"
                                name="total_number_doors"
                                id="total_number_doors"
                                wide
                                :errors="errors"
                            />
                            <text-row
                                label="Total no. of Audits"
                                v-model="form.total_number_audits"
                                type="number"
                                min="0"
                                step="1"
                                name="total_number_doors"
                                id="total_number_doors"
                                wide
                                :errors="errors"
                            />
                            <div class="row">
                                <div class="col-sm-12 col-md-6">
                                    <label for="engineer_id">Assessor</label>
                                </div>
                                <div class="col-xs-12 col-md-6 text-right">
                                    <user-select v-model="form.engineer_id" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <text-row
                                label="Number of pictures"
                                v-model="form.number_pictures"
                                type="number"
                                min="0"
                                step="1"
                                name="number_pictures"
                                id="number_pictures"
                                wide
                                :errors="errors"
                            />
                            <date-row
                                label="Date of assessment"
                                v-model="form.assessment_date"
                                name="assessment_date"
                                id="assessment_date"
                                :options="{format: 'L'}"
                                wide
                                :errors="errors"
                            />
                            <date-row
                                label="Last survey created"
                                v-model="form.last_survey_created"
                                name="last_survey_created"
                                id="last_survey_created"
                                wide
                                :options="{format: 'L'}"
                                :errors="errors"
                            />
                            <text-row
                                label="No. of non-compliant doors"
                                v-model="form.number_non_compliant_doors"
                                type="number"
                                min="0"
                                step="1"
                                name="number_non_compliant_doors"
                                id="number_non_compliant_doors"
                                wide
                                :errors="errors"
                            />
                            <text-row
                                label="Number of actions"
                                v-model="form.number_actions"
                                type="number"
                                min="0"
                                step="1"
                                name="number_actions"
                                id="number_actions"
                                wide
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Doors</h3>
                        </div>
                    </div>

                    <div
                        class="border mb-2"
                        v-for="(door, index) in form.doors"
                        :key="index"
                    >
                        <div
                            class="p-3 door-toggle-bar"
                            :class="`door-toggle-${index}`"
                            @click="openDoor(index)"
                        >
                            <span class="font-weight-bolder">
                                {{ `Door (${(index + 1)}): ${door.ref || '[Ref missing]'}` }}
                            </span>
                            <i
                                class="fa fa-chevron-down"
                                :class="{
                                    'fa-rotate-180': openDoorIndex === index
                                }"
                            />
                        </div>
                        <div
                            v-show="openDoorIndex === index"
                            class="p-3"
                        >
                            <text-row
                                :id="`door_ref_${index}`"
                                label="Door ref no."
                                v-model="form.doors[index].ref"
                                wide
                                :errors="errors"
                            />

                            <text-row
                                :id="`door_info_${index}`"
                                type="textarea"
                                label="Door info"
                                v-model="form.doors[index].info"
                                wide
                                :errors="errors"
                            />

                            <text-row
                                :id="`door_location_${index}`"
                                type="textarea"
                                label="Location"
                                v-model="form.doors[index].location"
                                wide
                                :errors="errors"
                            />

                            <text-row
                                :id="`door_potential_risk_${index}`"
                                type="textarea"
                                label="Potential risks"
                                v-model="form.doors[index].potential_risk"
                                wide
                                :errors="errors"
                            />

                            <text-row
                                :id="`door_defects_${index}`"
                                type="textarea"
                                label="Defects"
                                v-model="form.doors[index].defects"
                                wide
                                :errors="errors"
                            />

                            <text-row
                                :id="`door_corrective_actions_${index}`"
                                type="textarea"
                                label="Corrective actions"
                                v-model="form.doors[index].corrective_actions"
                                wide
                                :errors="errors"
                            />

                            <select-row
                                :id="`door_fire_rating_${index}`"
                                label="Fire Rating"
                                v-model="form.doors[index].fire_rating"
                                placeholder="Select rating"
                                :options="[
                                    'FD30',
                                    'FD60',
                                    'FD90',
                                    'FD120',
                                ]"
                                wide
                                :errors="errors"
                            />

                            <hr>

                            <div class="row">
                                <div class="col-sm-12">
                                    <h4>Fire Door</h4>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12 col-md-4">
                                    <text-row
                                        :id="`door_leaf_a_width_${index}`"
                                        label="Leaf A Width (mm)"
                                        v-model="form.doors[index].leaf_a_width"
                                        type="number"
                                        min="0"
                                        step="1"
                                        wide
                                        :errors="errors"
                                    />
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <text-row
                                        :id="`door_leaf_a_height_${index}`"
                                        label="Leaf A Height (mm)"
                                        v-model="form.doors[index].leaf_a_height"
                                        type="number"
                                        min="0"
                                        step="1"
                                        wide
                                        :errors="errors"
                                    />
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <text-row
                                        :id="`door_leaf_a_thickness_${index}`"
                                        label="Leaf A Thickness (mm)"
                                        v-model="form.doors[index].leaf_a_thickness"
                                        type="number"
                                        min="0"
                                        step="1"
                                        wide
                                        :errors="errors"
                                    />
                                </div>
                            </div>

                            <hr>

                            <div class="row">
                                <div class="col-sm-12 col-md-4">
                                    <text-row
                                        :id="`door_leaf_b_width_${index}`"
                                        label="Leaf B Width (mm)"
                                        v-model="form.doors[index].leaf_b_width"
                                        type="number"
                                        min="0"
                                        step="1"
                                        wide
                                        :errors="errors"
                                    />
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <text-row
                                        :id="`door_leaf_b_height_${index}`"
                                        label="Leaf B Height (mm)"
                                        v-model="form.doors[index].leaf_b_height"
                                        type="number"
                                        min="0"
                                        step="1"
                                        wide
                                        :errors="errors"
                                    />
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <text-row
                                        :id="`door_leaf_b_thickness_${index}`"
                                        label="Leaf B Thickness (mm)"
                                        v-model="form.doors[index].leaf_b_thickness"
                                        type="number"
                                        min="0"
                                        step="1"
                                        wide
                                        :errors="errors"
                                    />
                                </div>
                            </div>

                            <hr>

                            <select-row
                                :id="`door_has_label_${index}`"
                                label="Has the Fire Door got a label on the top edge, hinge side of the door or frame indicating it is certificated fire door? Or can you confirm that the door is meant to be a fire door?"
                                v-model="form.doors[index].has_label"
                                placeholder="Select option"
                                :options="[
                                    'Certified',
                                    'Notional',
                                    'Nominal',
                                ]"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`door_free_from_damage_${index}`"
                                label="Is the door and frame free from damage including dents, open joints, chips and holes? This includes any removed old locks, latches, keeps or refitted or removed hinges and spy holes etc"
                                v-model="form.doors[index].free_from_damage"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`veneered_or_lipped_${index}`"
                                label="If the door is veneered or lipped, is the glue still holding these products firmly in place?"
                                v-model="form.doors[index].veneered_or_lipped"
                                :options="['Yes', 'No', 'N/A']"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`leaf_flush_${index}`"
                                label="Does the door leaf sit against the door stop, flush with the frame and is it free of distortion?"
                                v-model="form.doors[index].leaf_flush"
                                :options="['Yes', 'No', 'N/A']"
                                :errors="errors"
                            />

                            <hr>

                            <h4>Door Frame</h4>

                            <div class="row">
                                <div class="col-sm-12 col-md-6">
                                    <text-row
                                        :id="`door_frame_width_${index}`"
                                        label="Frame Width (mm)"
                                        v-model="form.doors[index].frame_width"
                                        type="number"
                                        min="0"
                                        step="1"
                                        wide
                                        :errors="errors"
                                    />
                                </div>
                                <div class="col-sm-12 col-md-6">
                                    <text-row
                                        :id="`door_frame_height_${index}`"
                                        label="Frame Height (mm)"
                                        v-model="form.doors[index].frame_height"
                                        type="number"
                                        min="0"
                                        step="1"
                                        wide
                                        :errors="errors"
                                    />
                                </div>
                            </div>

                            <hr>

                            <checkbox-row
                                :id="`firmly_attached_${index}`"
                                label="Is the door frame firmly attached to the wall?"
                                v-model="form.doors[index].firmly_attached"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`leaf_material_checked_${index}`"
                                label="Check leaf and core are the correct material"
                                v-model="form.doors[index].leaf_material_checked"
                                :errors="errors"
                            />

                            <hr>

                            <text-row
                                :id="`lipping_thickness_${index}`"
                                label="Lipping thickness, if any (mm)"
                                v-model="form.doors[index].lipping_thickness"
                                type="number"
                                min="0"
                                step="1"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`twisting_of_leaf_${index}`"
                                label="Twisting of leaf"
                                v-model="form.doors[index].twisting_of_leaf"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`damage_or_cracking_${index}`"
                                label="Damaging or cracking"
                                v-model="form.doors[index].damage_or_cracking"
                                :errors="errors"
                            />

                            <hr>

                            <select-row
                                :id="`type_of_self_closer_${index}`"
                                label="Type of self closer fitted"
                                v-model="form.doors[index].type_of_self_closer"
                                placeholder="Select option"
                                :options="[
                                    'Overhead door closer',
                                    'Concealed closer',
                                    'Electromagnetic door closer',
                                    'Floor springs/hinge',
                                ]"
                                :errors="errors"
                                wide
                            />

                            <hr>

                            <checkbox-row
                                :id="`self_closer_attached_${index}`"
                                label="Is the self closer correctly attached?"
                                v-model="form.doors[index].self_closer_attached"
                                :options="['Yes', 'No', 'N/A']"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`self_closer_damaged_${index}`"
                                label="Is the closer free from damage and not leaking?"
                                v-model="form.doors[index].self_closer_damaged"
                                :options="['Yes', 'No', 'N/A']"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`close_and_latch_${index}`"
                                label="Open the door to 5 degrees or 75mm. Does it close and engage with the latch and door stop?"
                                v-model="form.doors[index].close_and_latch"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`unlatched_holds_in_frame_${index}`"
                                label="If unlatched, does the closer hold the door in line with the frame?"
                                v-model="form.doors[index].unlatched_holds_in_frame"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`latch_rattling_${index}`"
                                label="Does the latch hold the door firmly in place without rattling?"
                                v-model="form.doors[index].latch_rattling"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`pairs_close_${index}`"
                                label="If the doors are hung in pairs, do they close in line if both opened and released together?"
                                v-model="form.doors[index].pairs_close"
                                :options="['Yes', 'No', 'N/A']"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`planted_door_stop_attached_${index}`"
                                label="If a planted door stop is present, is it firmly attached?"
                                v-model="form.doors[index].planted_door_stop_attached"
                                :options="['Yes', 'No', 'N/A']"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`hold_open_devices_${index}`"
                                label="If applicable, do any 'hold open' device release the door when required? (only electronically powered allowed)"
                                v-model="form.doors[index].hold_open_devices"
                                :options="['Yes', 'No', 'N/A']"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`frame_to_door_gap_${index}`"
                                label="Is the frame to door leaf gap consistently 3mm? (tolerance of +/– 1mm)"
                                v-model="form.doors[index].frame_to_door_gap"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`bottom_gap_consistent_closed_${index}`"
                                label="Bottom Gap - Is the door to floor covering gap consistently 10mm or less when the door is closed?"
                                v-model="form.doors[index].bottom_gap_consistent_closed"
                                :errors="errors"
                            />

                            <hr>

                            <text-row
                                :id="`bottom_gap_measurement_${index}`"
                                label="Measurement of Bottom Gap"
                                v-model="form.doors[index].bottom_gap_measurement"
                                type="number"
                                min="0"
                                step="1"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`bottom_gap_consistent_swing_${index}`"
                                label="Is there a consistent gap under the door that allows it to swing without touching the floor covering?"
                                v-model="form.doors[index].bottom_gap_consistent_swing"
                                :errors="errors"
                            />

                            <hr>

                            <h4>Seals</h4>

                            <checkbox-row
                                :id="`intumescent_seals_paint_${index}`"
                                label="Are the fitted Intumescent seals free from paint or varnish?"
                                v-model="form.doors[index].intumescent_seals_paint"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`intumescent_seals_attached_${index}`"
                                label="Are the Intumescent seals well attached inside the groove in the frame or door leaf?"
                                v-model="form.doors[index].intumescent_seals_attached"
                                :errors="errors"
                            />

                            <hr v-show="form.doors[index].intumescent_seals_attached === 'No'">

                            <select-row
                                v-show="form.doors[index].intumescent_seals_attached === 'No'"
                                :id="`intumescent_seals_attached_info_${index}`"
                                label="Why aren't the Intumescent seals well attached?"
                                v-model="form.doors[index].intumescent_seals_attached_info"
                                :errors="errors"
                                :options="[
                                    'Loose/Detached',
                                    'Compressed/Straining',
                                    'Incorrect Type',
                                ]"
                            />

                            <hr>

                            <checkbox-row
                                :id="`intumescent_seals_damage_${index}`"
                                label="Are the Intumescent seals free from damage?"
                                v-model="form.doors[index].intumescent_seals_damage"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`intumescent_seals_size_type_${index}`"
                                label="Are the Intumescent seals correct size and all same type?"
                                v-model="form.doors[index].intumescent_seals_size_type"
                                :errors="errors"
                            />

                            <hr v-show="form.doors[index].intumescent_seals_size_type === 'No'">

                            <select-row
                                v-show="form.doors[index].intumescent_seals_size_type === 'No'"
                                :id="`intumescent_seals_size_issue_${index}`"
                                label="Why are the Intumescent seals incorrect sizes?"
                                v-model="form.doors[index].intumescent_seals_size_issue"
                                :errors="errors"
                                :options="[
                                    'Too small',
                                    'Too large'
                                ]"
                            />

                            <hr>

                            <checkbox-row
                                :id="`threshold_smoke_seal_damage_${index}`"
                                label="If fitted, is the threshold smoke seal present, undamaged, and functioning correctly by fully deploying to seal the gap when the door is closed?"
                                v-model="form.doors[index].threshold_smoke_seal_damage"
                                :errors="errors"
                                :options="['Yes', 'No', 'N/A']"
                            />

                            <hr v-show="form.doors[index].threshold_smoke_seal_damage === 'No'">

                            <select-row
                                v-show="form.doors[index].threshold_smoke_seal_damage === 'No'"
                                :id="`threshold_smoke_seal_damage_${index}`"
                                label="Threshold smoke seal damage type"
                                v-model="form.doors[index].threshold_smoke_seal_damage_type"
                                :errors="errors"
                                :options="[
                                    'Loose/Peeling',
                                    'Gaps/Rattling',
                                    'Improper Depth',
                                ]"
                            />

                            <hr>

                            <checkbox-row
                                :id="`brush_fin_smoke_seal_damage_${index}`"
                                label="If you have a brush or fin or acoustic type smoke seal, is it free from damage or breakage?"
                                v-model="form.doors[index].brush_fin_smoke_seal_damage"
                                :errors="errors"
                                :options="['Yes', 'No', 'N/A']"
                            />

                            <hr>

                            <h4>Hinges</h4>

                            <checkbox-row
                                :id="`hinges_marked_${index}`"
                                label="Are the Fire Door Hinges marked with a 'BS or EN' Number?"
                                v-model="form.doors[index].hinges_marked"
                                :errors="errors"
                            />

                            <hr>

                            <text-row
                                :id="`hinges_number_${index}`"
                                label="Number of Hinges fitted"
                                v-model="form.doors[index].hinges_number"
                                type="number"
                                min="0"
                                step="1"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`hinges_min_screws_${index}`"
                                label="Are there a minimum of 3 hinges with all the screws fitted?"
                                v-model="form.doors[index].hinges_min_screws"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`hinges_damage_${index}`"
                                label="Are the hinges free from packing and are the hinges free from metal fragments or oil leakage?"
                                v-model="form.doors[index].hinges_damage"
                                :errors="errors"
                            />

                            <hr>

                            <h4>Glazing</h4>

                            <text-row
                                :id="`number_vision_panels_${index}`"
                                label="Number of vision panels installed"
                                v-model="form.doors[index].number_vision_panels"
                                @input="handleVisionPanelsChanged(index)"
                                type="number"
                                min="0"
                                max="20"
                                step="1"
                                :errors="errors"
                            />

                            <hr>

                            <checkbox-row
                                :id="`panels_safety_class_${index}`"
                                label="If glazing panels are below 1500mm from the bottom of the door, is the glass safety glass and has a kite mark?"
                                v-model="form.doors[index].panels_safety_class"
                                :errors="errors"
                                :options="['Yes', 'No', 'N/A']"
                            />

                            <hr>

                            <checkbox-row
                                :id="`glass_intumescent_seal_${index}`"
                                label="Is there a visible intumescent seal between the Glass and Bead or its Rebate and is it continuous?"
                                v-model="form.doors[index].glass_intumescent_seal"
                                :errors="errors"
                                :options="['Yes', 'No', 'N/A']"
                            />

                            <hr>

                            <checkbox-row
                                :id="`glass_beads_damage_${index}`"
                                label="Are the glazing beads well attached to the frame and free from damage?"
                                v-model="form.doors[index].glass_beads_damage"
                                :errors="errors"
                                :options="['Yes', 'No', 'N/A']"
                            />

                            <hr v-show="form.doors[index].glass_beads_damage === 'No'">

                            <select-row
                                v-show="form.doors[index].glass_beads_damage === 'No'"
                                :id="`glass_beads_damage_${index}`"
                                label="Why aren't the glazing beads well attached to the frame and free from damage?"
                                v-model="form.doors[index].glass_beads_damage_type"
                                :errors="errors"
                                :options="[
                                    'Packing Present',
                                    'Metal Fragments/Damage',
                                    'Oil Leakage',
                                ]"
                            />

                            <hr>

                            <checkbox-row
                                :id="`glass_damage_${index}`"
                                label="Is the glass free from damage and cracking?"
                                v-model="form.doors[index].glass_damage"
                                :errors="errors"
                                :options="['Yes', 'No', 'N/A']"
                            />

                            <hr>

                            <checkbox-row
                                :id="`glass_replaced_${index}`"
                                label="If the glass has been replaced, is it a fire rated glass? "
                                v-model="form.doors[index].glass_replaced"
                                :errors="errors"
                                :options="['Yes', 'No', 'N/A']"
                            />

                            <hr>

                            <h4>Letter Box & Vent Grill</h4>

                            <checkbox-row
                                :id="`letter_box_fitted_${index}`"
                                label="Is the door fitted with a Letter box? If yes please complete the below"
                                v-model="form.doors[index].letter_box_fitted"
                                :errors="errors"
                            />

                            <div
                                v-if="form.doors[index].letter_box_fitted === 'Yes'"
                                class="row"
                            >
                                <div class="col-sm-12 col-md-6">
                                    <text-row
                                        :id="`letter_box_markings_${index}`"
                                        label="Markings"
                                        v-model="form.doors[index].letter_box_markings"
                                        :errors="errors"
                                        wide
                                    />
                                </div>
                                <div class="col-sm-12 col-md-6">
                                    <text-row
                                        :id="`letter_box_size_${index}`"
                                        label="Size"
                                        v-model="form.doors[index].letter_box_size"
                                        :errors="errors"
                                        wide
                                    />
                                </div>
                                <div class="col-sm-12 col-md-6">
                                    <text-row
                                        :id="`letter_box_framing_${index}`"
                                        label="Framing"
                                        v-model="form.doors[index].letter_box_framing"
                                        :errors="errors"
                                        wide
                                    />
                                </div>
                                <div class="col-sm-12 col-md-6">
                                    <text-row
                                        :id="`letter_box_height_${index}`"
                                        label="Height"
                                        v-model="form.doors[index].letter_box_height"
                                        :errors="errors"
                                        wide
                                    />
                                </div>
                            </div>

                            <hr>

                            <checkbox-row
                                :id="`vent_grill_fitted_${index}`"
                                label="Is the door fitted with a Vent Grill? If yes please complete the below."
                                v-model="form.doors[index].vent_grill_fitted"
                                :errors="errors"
                            />

                            <div
                                v-if="form.doors[index].vent_grill_fitted === 'Yes'"
                                class="row"
                            >
                                <div class="col-sm-12 col-md-4">
                                    <text-row
                                        :id="`vent_grill_markings_${index}`"
                                        label="Markings"
                                        v-model="form.doors[index].vent_grill_markings"
                                        :errors="errors"
                                        wide
                                    />
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <text-row
                                        :id="`vent_grill_size_${index}`"
                                        label="Size"
                                        v-model="form.doors[index].vent_grill_size"
                                        :errors="errors"
                                        wide
                                    />
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <text-row
                                        :id="`vent_grill_height_${index}`"
                                        label="Height"
                                        v-model="form.doors[index].vent_grill_height"
                                        :errors="errors"
                                        wide
                                    />
                                </div>
                            </div>

                            <hr>

                            <h4>Side Panels</h4>

                            <text-row
                                :id="`panel_makeup_${index}`"
                                label="Panel make-up"
                                v-model="form.doors[index].panel_makeup"
                                type="textarea"
                                wide
                                :errors="errors"
                            />

                            <hr>

                            <text-row
                                :id="`panel_size_${index}`"
                                label="Panel size"
                                v-model="form.doors[index].panel_size"
                                wide
                                :errors="errors"
                            />

                            <hr>

                            <text-row
                                :id="`type_of_glass_${index}`"
                                label="Type of glass"
                                v-model="form.doors[index].type_of_glass"
                                wide
                                :errors="errors"
                            />

                            <hr>

                            <text-row
                                :id="`side_panel_beading_${index}`"
                                label="Beading"
                                v-model="form.doors[index].side_panel_beading"
                                wide
                                :errors="errors"
                            />

                            <hr>

                            <text-row
                                :id="`identity_mark_on_glass_${index}`"
                                label="Identity mark on glass"
                                v-model="form.doors[index].identity_mark_on_glass"
                                wide
                                :errors="errors"
                            />

                            <hr>

                            <text-row
                                :id="`panel_fixing_method_${index}`"
                                label="Panel fixing method"
                                v-model="form.doors[index].panel_fixing_method"
                                type="textarea"
                                wide
                                :errors="errors"
                            />

                            <hr>

                            <h4>Corrective Actions /Additional Comments</h4>

                            <div class="row">
                                <div class="col-sm-12">
                                    <textarea
                                        rows="10"
                                        class="form-control"
                                        v-model="form.doors[index].corrective_actions_comments"
                                        placeholder="Type comments in here or click the autofill button below..."
                                    />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12 text-right">
                                    <button
                                        class="btn btn-info"
                                        @click.prevent="autofillCorrectiveActions(index)"
                                    >
                                        Autofill corrective actions
                                    </button>
                                </div>
                            </div>

                            <hr>

                            <h4>Photos</h4>

                            <audit-rows
                                v-model="form.doors[index].photos"
                                add-row-label="Add Photo Row"
                                delete-row-label="Delete Photo Row"
                            />

                            <div class="row">
                                <div class="col-sm-12 text-right">
                                    <button
                                        v-if="form.doors && form.doors.length > 1"
                                        class="btn btn-danger"
                                        type="button"
                                        @click.prevent="removeDoor(index)"
                                    >
                                        <i class="fa fa-trash" />
                                        Remove Door
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 text-right">
                            <button
                                type="button"
                                class="btn btn-info"
                                @click.prevent="addDoor"
                            >
                                <i class="fa fa-plus" />
                                Add Door
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row form-group">
                        <div class="col-12">
                            <button
                                class="btn btn-success"
                                type="submit"
                                :disabled="isSaving || isLoading"
                            >
                                Save
                            </button>

                            <button
                                class="btn btn-outline-danger"
                                type="button"
                                @click.prevent="deleteForm()"
                                :disabled="isSaving || isLoading"
                                v-if="form.id && canDelete"
                            >
                                <i class="fa fa-times" /> Delete
                            </button>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/stream'"
                                target="_blank"
                            >
                                <i class="fa fa-print" /> Preview/Print
                            </a>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/download'"
                                target="_blank"
                                :download="form.doc_no + '.pdf'"
                            >
                                <i class="fa fa-file" /> Download PDF
                            </a>

                            <router-link
                                class="btn btn-info"
                                v-if="form.id"
                                :to="{name: 'office.emails.new', params: {customer_id: form.customer_id}, query: {form_id: form.id}}"
                            >
                                <i class="fa fa-envelope" /> Send to Customer
                            </router-link>

                            <router-link
                                :to="{name: 'engineer.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'engineer.forms.edit' && form.job_id"
                            >
                                <i class="fa fa-chevron-left" /> Back to Job
                            </router-link>

                            <router-link
                                :to="{name: 'office.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'office.forms.edit' && form.job_id"
                            >
                                <i class="fa fa-briefcase" /> View Job
                            </router-link>

                            <customer-site-footer-links
                                :customer-id="form.customer_id"
                                :site-id="form.site_id"
                            />

                            <activity-log
                                v-if="form.id"
                                :id="form.id"
                                model="Form"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<style scoped lang="scss">
.door-toggle-bar {
    display: flex;
    justify-content: space-between;
    background-color: #eaeaea;
    align-items: center;
    cursor: pointer;

    &:hover {
        background-color: #d4d4d4;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/FireDoorInspection.vue